import { Component, Inject, Input, OnInit } from 'ng-metadata/core';
import './badge.component.scss';

type MwBadgePosition = 'above-after' | 'above-before' | 'below-before' | 'below-after';

/**
 * @ngdoc directive
 * @name mwBadge
 * @module mw.components.badge
 *
 * @param {string} [position] - The title to be displayed in the header.
 * @param {number} [count] - Control if the badge is open.
 *
 * @description
 * `<md-badge>` is a component used to display a simple collapsible panel controlled through a click action on a button located in the header of the badge. Both the badge header, and the badge content allow transclusion of other elements into their respective views.  Elements transcluded into the header will appear after the title.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-badge count="3"></mw-badge>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-badge',
    template: `
        <span class="mw-badge">{{$ctrl.displayCount}}</span>
    `
})
export class BadgeComponent implements OnInit {
    @Input('<') count: number = 0;
    @Input('@') position: MwBadgePosition = 'above-after';

    constructor(@Inject('$element') private $element: ng.IRootElementService) {
        'ngInject';
    }

    ngOnInit() {
        this.$element.addClass('mw-badge-pos--' + this.position);
    }

    get displayCount(): string | number {
        if (typeof this.count === 'number') {
            return this.count > 99 ? '99+' : this.count;
        }

        return '-';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/badge/badge.component.ts